<template>
  <div :class="['section-header-wrapper', { 'locale-zh-CN': isZhLocale }]">
    <div
      class="section-header"
      :class="{ 'has-extra-action': showExtraAction && extraActionText }"
    >
      <div class="header-left">
        <div class="title-block">
          <h3 class="section-title">{{ title }}</h3>
          <span v-if="isZhLocale && subtitle" class="section-subtitle">{{ subtitle }}</span>
        </div>
        <!-- 紧挨标题右侧 -->
        <div
          v-if="showExtraAction && extraActionText"
          class="extra-action"
          @click="handleExtraActionClick"
        >
          <span class="extra-action-icon" />
          <span class="extra-action-text">{{ extraActionText }}</span>
        </div>
      </div>

      <!-- 主分类标签（居中） -->
      <MainCategoryTabs
        v-if="mainTabs && mainTabs.length"
        :tabs="mainTabs"
        :active-tab="activeMainTab"
        @tab-change="handleMainTabChange"
      />

      <div class="more-link" @click="handleMoreClick">{{ moreText }}</div>
    </div>

    <!-- 子分类标签 -->
    <SubCategoryTabs
      v-if="visibleSubTabs.length"
      :tabs="visibleSubTabs"
      :active-tab="activeSubTab"
      @tab-change="handleSubTabChange"
    />
  </div>
</template>

<script>
import MainCategoryTabs from '@/components/MainCategoryTabs.vue'
import SubCategoryTabs from '@/components/SubCategoryTabs.vue'
import { getText } from '@/utils/i18nText'
import { getVisibleSubCategoryTabs } from '@/utils/filterTabs'

export default {
  name: 'SectionHeader',
  components: {
    MainCategoryTabs,
    SubCategoryTabs
  },
  props: {
    // 标题
    title: {
      type: String,
      required: true
    },
    // 副标题
    subtitle: {
      type: String,
      default: ''
    },
    // 主分类标签
    mainTabs: {
      type: Array,
      default: () => []
    },
    // 子分类标签
    subTabs: {
      type: Array,
      default: () => []
    },
    // 激活的主标签
    activeMainTab: {
      type: String,
      default: ''
    },
    // 激活的子标签
    activeSubTab: {
      type: String,
      default: ''
    },
    // 更多文本
    moreText: {
      type: String,
      default: () => getText('sectionHeader.moreText', '更多>')
    },
    // 额外动作文案（如：揭榜挂帅）
    extraActionText: {
      type: String,
      default: ''
    },
    // 是否展示额外动作
    showExtraAction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleSubTabs() {
      return getVisibleSubCategoryTabs(this.subTabs)
    }
  },
  methods: {
    handleMainTabChange(tab) {
      this.$emit('main-tab-change', tab)
    },

    handleSubTabChange(tab) {
      this.$emit('sub-tab-change', tab)
    },

    handleMoreClick() {
      this.$emit('more-click')
    },
    handleExtraActionClick() {
      this.$emit('extra-action-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.section-header-wrapper {
  margin-bottom: 20px;

  &.locale-zh-CN .section-header {
    .header-left .section-title {
      font-size: 25px;
    }

    .header-left .section-subtitle {
      font-size: 14px;
    }

    .more-link {
      font-size: 16px;
    }

    &.has-extra-action .extra-action-text {
      font-size: 18px;
    }
  }
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 19px;
  position: relative;

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;

    .title-block {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      gap: 10px;
    }

    .section-title {
      font-family: FZZhengHeiS-DB-GB;
      font-weight: 400;
      font-size: 24px;
      color: #333333;
      line-height: 26px;
      margin: 0;
    }

    .section-subtitle {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #AA9A4C;
      text-transform: uppercase;
      letter-spacing: 1px;
      white-space: nowrap;
    }
  }

  .more-link {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #A0903C;
    line-height: 36px;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    z-index: 1;

    &:hover {
      text-decoration: underline;
    }
  }

  .extra-action {
    height: 48px;
    min-width: auto;
    margin-left: 0;
    padding: 0 20px 0 16px;
    border-radius: 2px;
    background-color: #f5f6f2;
    background-image: url('~@/assets/img/gongxuzhongxin/jiebang/beijing.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;

    &:hover {
      background-color: #f0f2eb;
    }

    .extra-action-icon {
      width: 18px;
      height: 22px;
      position: relative;
      flex-shrink: 0;
      background-image: url('~@/assets/img/gongxuzhongxin/jiebang/jiebang-ico.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .extra-action-text {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      line-height: 1.1;
      color: #887825;
      white-space: nowrap;
      letter-spacing: 0;
    }
  }
}
</style>
